// extracted by mini-css-extract-plugin
export default {"icon":"cGpxQtIqew7YwYPW5CEg"};